<template>
 <div class="wrap talk  re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2 v-if="sysGbn === 'BARRIER'">번호 인증</h2>
						<h2 v-else>본인 인증</h2>
							</section>
			          <section>
			            <div v-if="sysGbn === 'BARRIER'" class="box row row_c row_jsc">
			              <h1>번호 확인</h1>
			              <p>상담사에게 아래번호</p>
			              <p>{{randomNumber}}을(를) 말씀해 주세요</p>
			              <br/>
			              <br/>
			              <br/>
			              <h1 style="font-size:70px;">{{randomNumber}}</h1>
									</div>
			            <div v-else class="box row row_c row_jsc">
			              <h1>기기 확인</h1>
			              <p>계속하려면 {{sysGbn}}에서 다음 번호</p>
			              <p>{{randomNumber}}을(를) 입력해주세요</p>
			              <br/>
			              <br/>
			              <br/>
			              <h1 style="font-size:70px;">{{randomNumber}}</h1>
									</div>
			          </section>
			          <div class="btn-wrap" style="margin-top:27px;">
							<a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="complete()">확인</a>
						</div>
						<section>
						 <div class="row row_c row_jsc" style="position: relative; text-align: center;
						 margin-top: 45px; line-height: 20px; color: #8b8b8b;">
			              <h1 style="margin-bottom: 10px;">고객센터 문의</h1>
			              <p>일반 민팃 : 1877-5446</p>
			              <p>SKT 민팃 : 1877-2660 &emsp; &emsp; KT 민팃 : 1877-4515</p>
						</div>
						</section>
					</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'RandomNum',
  components: {

  },
  data: () => ({
    AppConfig: AppConfig,
    isProc: false
  }),
  computed: {
    randomNumber () {
      return this.$route.query.rn
    },
    sysGbn () {
      return this.$route.query.sysGbn
    }
  },
  mounted () {

  },
  methods: {

    async complete () {
	  const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/crtfpass/RandomNum.vue